import React,{useState, useEffect} from 'react';
import { ListGroup, Row, Col, Image} from 'react-bootstrap';
import { Navbar, Nav, Container} from 'react-bootstrap';
import StarLineage from './spread/starlineage';
import Karmic from './spread/karmic';
import HigherGuidance from './spread/higher';
import CurrentInfluence from './spread/current';
import Chakra from './spread/chakra';
import Personal from './spread/personal';
import Free from './spread/free';
import { isBrowser, isMobileSafari, isMobile } from 'react-device-detect';
import { useLanguage } from '../i18n/LanguageContext';

function Spread(props) {
  const { t } = useLanguage();
  const [currentSpread, setSpread] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
  
  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);
  
  function handleClick(spread){
    setSpread(spread);
  }

  function handleBack(){
    setSpread("");
    props.onSubSelect();
  }

  if (currentSpread == "starlineage"){
    return (<div>
      <StarLineage theme={props.theme} onBackSelected={handleBack}></StarLineage>
    </div>)
  }
  else if (currentSpread == "karmic"){
    return (<div>
      <Karmic theme={props.theme} onBackSelected={handleBack}></Karmic>
     </div>)
  }
  else if (currentSpread == "higher"){
    return (<div>
      <HigherGuidance theme={props.theme} onBackSelected={handleBack}></HigherGuidance>
      </div>)
  }
  else if (currentSpread == "personal"){
    return (<div>
      <Personal theme={props.theme} onBackSelected={handleBack}></Personal>
     </div>)
  }
  else if (currentSpread == "free"){
    return (<div>
      <Free theme={props.theme} onBackSelected={handleBack}></Free>
     </div>)
  }
  else if (currentSpread == "current"){
    return (<div>
      <CurrentInfluence theme={props.theme} onBackSelected={handleBack}></CurrentInfluence>
      </div>)
  }
  else if (currentSpread == "chakra"){
    return (<div>
      <Chakra theme={props.theme} onBackSelected={handleBack}></Chakra>
      </div>)
  }
  else{
    var cHeight = '100vh';
    if (isBrowser || isMobileSafari){
      cHeight = height + 'px';
    }

    //onTouchEnd={handleClick.bind(this, "starlineage")}
    return (
    <div>
      <Navbar fixed="top" bg={props.theme} className="justify-content-end" variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
        <Container>
        <Nav className="me-auto">
        <Navbar.Brand className="justify-content-center align-self-center">{t('spreads.header')}</Navbar.Brand>
        </Nav>
        </Container>
    </Navbar>
    <Container fluid style={{overflow:'auto', width:'100%',paddingLeft:0, paddingRight:0, paddingTop:'50px',paddingBottom:'85px', height: 'calc(' + cHeight + ' - 88px - env(safe-area-inset-top))'}}>
     <ListGroup>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "starlineage")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/starlineage.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col><div><b>{t('spreads.starlineage.title')}</b></div>
             <div className="r2">{t('spreads.starlineage.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "karmic")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/karmic.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col><div><b>{t('spreads.karmic.title')}</b></div>
        <div className="r2">{t('spreads.karmic.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "higher")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/higher.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col><div><b>{t('spreads.higher.title')}</b></div>
        <div className="r2">{t('spreads.higher.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "personal")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/personal.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col> <div><b>{t('spreads.personal.title')}</b></div>
       <div className="r2">{t('spreads.personal.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "current")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/CurrentInfluence.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col> <div><b>{t('spreads.current.title')}</b></div>
       <div className="r2">{t('spreads.current.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "chakra")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/chakra.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col> <div><b>{t('spreads.chakra.title')}</b></div>
       <div className="r2">{t('spreads.chakra.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
      <ListGroup.Item variant={props.theme} action onClick={handleClick.bind(this, "free")}>
      <Row>
        <Col xs={3} className="justify-content-center align-self-center mx-auto" style={{width:'22%'}}><Image src="graphics/free.png" thumbnail style={{height: '50px', width: '50px'}} /></Col>
        <Col> <div><b>{t('spreads.free.title')}</b></div>
       <div className="r2">{t('spreads.free.desc')}</div>
        </Col>
      </Row>
      </ListGroup.Item>
  </ListGroup>
  </Container>
    </div>
  )
  }
};

export default Spread;